const mainDomain = "https://api.vasaabacus.com/";
const imageDomain = "https://api.vasaabacus.com";

// const mainDomain = "https://coretest.agriquiz.in/";
// const imageDomain = "https://coretest.agriquiz.in";

// const mainDomain = "http://192.168.1.8:9001/";
// const imageDomain = "http://192.168.1.8:9001";

const Constants = {
  imageDomain,
  getUrls: {
    getAboutUs: mainDomain + "about-us/",
    getAllTestimonials: mainDomain + "testimonial",
    getDashboard: mainDomain + "dashboard/my-dash",
    getAdminDasboard: mainDomain + "dashboard/admin-dash",
    getAllContacts: mainDomain + "contacts",
    getAllBlogs: mainDomain + "blogs/list-dash",
    getAllBlogCategories: mainDomain + "blog-categories/",
    getAllWebContacts: mainDomain + "web-contact/list-dash",
    getAllNotifications: mainDomain + "notifications/list",
    getAllAlumini: mainDomain + "alumini",
    getAllEvents: mainDomain + "event",
    getGallery: mainDomain + "gallery",
    getAllCourses: mainDomain + "courses/list-dash",
    getAllFranchiseEnquiry: mainDomain + "franchise-enquiry",
    getSocialMedia: mainDomain + "social-media",
    getSchoolEnquiry: mainDomain + "school-enquiry",
    getAllBanners: mainDomain + "banner",
    getAllExams: mainDomain + "exams/list-dash",
    getAllCounts: mainDomain + "counts",
    getAllTeams: mainDomain + "teams",
    getAllFaqs: mainDomain + "faqs",
    getAllAmenities: mainDomain + "amenities",
    getAllNavbarTexts: mainDomain + "navbartext",
    getRequestDemo: mainDomain + "demos",
    getAllYoutubeSlider: mainDomain + "youtube-slider",
    getAbacusSchool: mainDomain + "abacus-school/",
    getAllAbacusCourses: mainDomain + "abacus-course",
    getAllYoutube: mainDomain + "all-youtube",
  },
  postUrls: {
    saveAllYoutube: mainDomain + "all-youtube/save",
    createAbacusCourse: mainDomain + "abacus-course/create",
    createAbacusSchool: mainDomain + "abacus-school",
    createBlogCategory: mainDomain + "blog-categories/create",
    createBlogs: mainDomain + "blogs/create",
    createNewNotification: mainDomain + "notifications/create-dash",
    employerLogin: mainDomain + "admin/login",
    createTestimonial: mainDomain + "testimonial/create",
    addNewAlumini: mainDomain + "alumini/create",
    addNewEvent: mainDomain + "event/create",
    addGallery: mainDomain + "gallery",
    addNewCourse: mainDomain + "courses/create",
    addSocialMedia: mainDomain + "social-media",
    addBanner: mainDomain + "banner/create",
    sendMailFranchise: mainDomain + "franchise-enquiry/sendMail",
    createExam: mainDomain + "exams/create",
    createCount: mainDomain + "counts/create",
    createTeam: mainDomain + "teams/create",
    createFaq: mainDomain + "faqs/create",
    createAmenity: mainDomain + "amenities/create",
    createNavbarText: mainDomain + "navbartext/create",
    createAboutUs: mainDomain + "about-us/create",
    createYoutubeSlider: mainDomain + "youtube-slider/create",
  },
  putUrls: {
    updateAbacusCourse: mainDomain + "abacus-course/update/",
    updateAbacusSchool: mainDomain + "abacus-school",
    updateYoutubeSlider: mainDomain + "youtube-slider/update/",
    updateAboutUs: mainDomain + "about-us/update/",
    updateBlogCategory: mainDomain + "blog-categories/update/",
    updateBlogs: mainDomain + "blogs/update/",
    updateTestimonial: mainDomain + "testimonial/update/",
    updateAlumini: mainDomain + "alumini/update/",
    updateEvent: mainDomain + "event/update/",
    updateCourses: mainDomain + "courses/update/",
    toggleCourseStatus: mainDomain + "courses/toggle-status",
    updateSocialMedia: mainDomain + "social-media",
    updateBanner: mainDomain + "banner/update",
    updateExam: mainDomain + "exams/update/",
    updateCount: mainDomain + "counts/update/",
    updateTeam: mainDomain + "teams/update/",
    updateFaq: mainDomain + "faqs/update/",
    updateAmenity: mainDomain + "amenities/update/",
    updateNavbarText: mainDomain + "navbartext/update/",
    toggleExamStatus: mainDomain + "exams/toggle-status/",
  },
  deleteUrls: {
    deleteAbacusCourse: mainDomain + "abacus-course/delete/",
    deleteBanner: mainDomain + "banner/delete/",
    deleteAbout: mainDomain + "about-us/delete/",
    deleteSubject: mainDomain + "subject/delete/",
    deletePopup: mainDomain + "popup/delete/",
    deleteTestimonial: mainDomain + "testimonial/delete/",
    deleteGalleryImage: mainDomain + "gallery/",
    deleteAlumini: mainDomain + "alumini/delete/",
    deleteEvent: mainDomain + "event/delete/",
    deleteBlogCategory: mainDomain + "blog-categories/delete/",
    deleteBlog: mainDomain + "blogs/delete/",
    deleteCourse: mainDomain + "courses/",
    deleteSocialMedia: mainDomain + "social-media",
    deleteSchoolEnquiry: mainDomain + "school-enquiry",
    deleteBaner: mainDomain + "banner/delete",
    deleteExam: mainDomain + "exams/",
    deleteCount: mainDomain + "counts/delete/",
    deleteTeam: mainDomain + "teams/delete/",
    deleteFaq: mainDomain + "faqs/delete/",
    deleteAmenity: mainDomain + "amenities/delete/",
    deleteNavbarText: mainDomain + "navbartext/delete/",
    deleteRequestDemo: mainDomain + "demos/delete/",
    deleteYoutubeSlider: mainDomain + "youtube-slider/delete/",
  },
};

export default Constants;
